<template>
  <stripe-checkout
    ref="checkoutRef"
    :pk="publishableKey"
    :items="items"
    :successUrl="successUrl"
    :cancelUrl="cancelUrl"
  >
    <template slot="checkout-button">
      <Button @click="checkout" secondary>{{ label }}</Button>
    </template>
  </stripe-checkout>
</template>

<script>
import { StripeCheckout } from "vue-stripe-checkout";
import Button from "@/components/Common/Button";
import { mapState } from "vuex";
export default {
  name: "CheckoutStripeButton",
  components: {
    StripeCheckout,
    Button
  },
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState({
      publishableKey: state => state.stripe.publishableKey,
      items: state => state.stripe.items,
      successUrl: state => state.stripe.successUrl,
      cancelUrl: state => state.stripe.cancelUrl
    })
  },
  methods: {
    checkout() {
      this.$refs.checkoutRef.redirectToCheckout();
    }
  }
};
</script>
